import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Inject,
} from "@angular/core";
import { Observable } from "rxjs";
import { FormControl } from "@angular/forms";
import { map, startWith } from "rxjs/operators";
import { of } from "rxjs";
declare const $: any;

export interface List {
  id: string;
  name: string;
}

@Component({
  selector: "select-filter",
  templateUrl: "./select-filter.component.html",
  styleUrls: ["./select-filter.component.css"],
})
export class SelectFilterComponent implements OnInit {
  @Input() id = "select";
  @Input() label = "";
  @Input() selectedPrev: number = null;
  @Input() selectedPrevName: string = null;
  @Input() plholder = "Locations";
  @Input() msgeOption = "Select an option";
  @Input() type = "any";
  @Input() length = 0;
  @Input() fullValue = false;
  @Input() options: Array<any> = [];

  @Output() changeOption: EventEmitter<number>;

  public filteredOptions: Observable<List[]>;
  public optionSelected = "";
  public myControl = new FormControl();

  filtrados: List[] = [];

  constructor() {
    this.changeOption = new EventEmitter();
  }

  private _filterClientes(name: string): List[] {
    if (this.type === "po" || this.type === "poFull") {
      const filterValue = name;
      return this.filtrados.filter((option) =>
        option.name.includes(filterValue)
      );
    } else {
      const filterValue = name.toLowerCase();
      return this.filtrados.filter((option) =>
        option.name.toLowerCase().includes(filterValue)
      );
    }
  }

  public tocado = true;
  initFilter() {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(""),
      map((value) => (typeof value === "string" ? value : value?.name || "")),
      map((name) => this._filterClientes(name))
    );
  }
  ngOnInit() {
    this.initFilter();

    console.log(this.filteredOptions);

    let item;
    console.log(this.selectedPrev);
    console.log(this.options);
    console.log(this.type);
    for (item of this.options) {
      let id;
      let name;
      if (this.type === "location") {
        name =
          item.locationName +
          ": " +
          item.locationRow +
          "-" +
          item.locationBay +
          "-" +
          item.locationLevel +
          "-" +
          item.locationSection;
      } else if (this.type === "newlocation") {
        name =
          item.location.name +
          " - " +
          item.locationName +
          ": " +
          item.locationRow +
          "-" +
          item.locationBay +
          "-" +
          item.locationLevel +
          "-" +
          item.locationSection;
      } else if (this.type === "po" || this.type === "poFull") {
        name = String(item.po);
      } else if (this.type === "users") {
        name = item.name + " " + item.surname;
      } else if (this.type === "vendors") {
        //name = item.name + ' ' + item.surname + ' - ' + item.namecompany;
        name = item.name;
      } else {
        name = item.name;
      }

      id = item.id;

      if (this.type === "newlocation" && this.length > 5 && item.id === 777)
        continue;

      this.filtrados.push({
        id: id,
        name: name,
      });
      if (
        this.selectedPrev === id &&
        this.selectedPrevName != "" &&
        this.selectedPrevName != null
      ) {
        this.optionSelected = name;
        this.tocado = false;
      }
    }

    console.log(this.selectedPrevName);
    console.log(this.optionSelected);
  }

  deshabilitar(option) {
    return option.id == this.selectedPrev;
  }

  cambiar() {
    // debugger
    console.log(this.id);
    this.tocado = true;
    setTimeout(function () {
      $("#" + this.id).focus();
    }, 250);
  }

  displayFn(user?: List): string | undefined {
    return user ? user.name : undefined;
  }
  resetValue() {
    this.optionSelected = null;
    this.myControl.reset();
    this.initFilter(); // Reinicia el observable del filtro
  }
  OnHumanSelected(option) {
    console.log(option);
    if (this.type === "poFull" || this.fullValue) {
      this.changeOption.emit(option.value);
    } else {
      this.changeOption.emit(option.value.id);
    }
  }
}
